import React from "react";

/**
 * Price in millions.
 */
const PriceInMillions = ({
  price,
  baseClassName,
  prefix,
  decimalPrecision = 2,
  addSpaceBeforeSuffix = false
}) => {
  if (typeof prefix === "undefined") {
    prefix = "$";
  }

  if (typeof price !== "number") {
    return <div className={baseClassName}>n/a</div>;
  }

  const space = addSpaceBeforeSuffix ? " " : "";

  let newPrice;
  if (price < 0) {
    newPrice = (price / 1000000).toFixed(decimalPrecision) * -1;
    return (
      <div className={baseClassName}>{`-${prefix}${newPrice}${space}M`}</div>
    );
  } else {
    newPrice = (price / 1000000).toFixed(decimalPrecision);
    return (
      <div className={baseClassName}>{`${prefix}${newPrice}${space}M`}</div>
    );
  }
};

export default PriceInMillions;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/numbers/PriceInMillions.js